import React from 'react';
import { Button, Card, IconButton, LinearProgress, Tooltip, Typography } from '@mui/material';
import { IoPlay, IoPause } from "react-icons/io5";


const SFCategoryProgressCard = ({allowPauseCategory, isCurrent, score, title, isMobile, isPaused, handleResumeCategory, handlePauseCategory, categoryKey }) => {
    return (
        <Card className='px-3 py-2 d-flex justify-content-between flex-column position-relative' sx={{ boxShadow: 3, height: isMobile ? '82px' : '90px', }}
            tabIndex={0}
            aria-label={`${title}, ${score}% progress${isPaused ? ", paused" : ""}`}
            style={{
                // border: isCurrent ? '2px solid #333' : '',
                borderRadius: 8,
                minWidth: isMobile ? '78px' : '180px',
                maxWidth: isMobile ? '120px' : "220px",
                background: isPaused ? "#e0e0e0" : '#fff',
                borderTop: "4px solid",
                borderColor: isPaused ? "#e0e0e0" : ( isCurrent ? "#bb0000" : "#fff"),
            }}>
            <div className='d-flex justify-content-between align-items-start'>
                <Tooltip sx={{
                    background: "#333",
                }}
                    enterTouchDelay={0}
                    arrow
                    title={
                        <Typography sx={{ color: "#fff" }} fontSize={12}>
                            {title}
                        </Typography>
                    } placement="top">
                    <Typography
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: '2',
                            WebkitBoxOrient: 'vertical',
                            color: isPaused ? "#adadad" : '#333'
                        }}
                        fontWeight={'500'}
                        fontSize={13}>
                        {title} {isPaused ? "(Paused)" : ""}
                    </Typography>
                </Tooltip>
                {allowPauseCategory ? 
                score !== 100 ?
                    isPaused ?
                        <span className='resume-cat-btn'>
                            <Tooltip title="Category is paused. Click to resume.">
                                <IconButton
                                    aria-label="Resume category"
                                    onClick={() => {
                                        handleResumeCategory(categoryKey)
                                    }}
                                    size='small'>
                                    <IoPlay color='#fff' />
                                </IconButton>
                            </Tooltip>
                        </span>
                        :
                        <span className='pause-cat-btn'>
                            <Tooltip title="You may choose to pause a category. Questions from a paused category will not be presented until the category is un-paused(resumed)">
                                <IconButton
                                    aria-label="Pause category"
                                    onClick={() => {
                                        handlePauseCategory(categoryKey)
                                    }}
                                    size='small'>
                                    <IoPause />
                                </IconButton>
                            </Tooltip>
                        </span>
                    : null
                : null}
            </div>

            <div className=''>
                <Typography
                    style={{
                        color: isPaused ? "#adadad" : '#333'
                    }}
                    fontSize={14}>{score}%</Typography>
                <LinearProgress
                    sx={{
                        backgroundColor: '#eff1f2',
                        '& .MuiLinearProgress-bar': {
                            backgroundColor: '#bfc6cb',
                        },
                    }}
                    style={{
                        height: '8px',
                        borderRadius: '75px',
                        // background: isCurrent && '#fff',
                    }} variant="determinate" value={score} />
            </div>
        </Card>
    );
}

export default SFCategoryProgressCard;
